var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ach-form-dialog" }, [
    _c("header", { staticClass: "ach-form-heading" }, [
      _c(
        "span",
        { staticClass: "ach-form-icon", attrs: { "aria-hidden": "true" } },
        [_c("portal-icon", { attrs: { name: "landmark", size: 21 } })],
        1
      ),
      _c("h2", [_vm._v(_vm._s(_vm.$t("invoices.manual-ach.account-info")))]),
      _c(
        "button",
        {
          staticClass: "dialog-close",
          attrs: { type: "button", "aria-label": _vm.$t("global.close") },
          on: { click: _vm.handleClose }
        },
        [_c("portal-icon", { attrs: { name: "x", size: 19 } })],
        1
      )
    ]),
    _vm.stripeAccountId
      ? _c(
          "div",
          { staticClass: "ach-form-body" },
          [
            _c(
              "v-form",
              {
                ref: "accountForm",
                staticClass: "ach-field-grid",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                },
                model: {
                  value: _vm.isValid,
                  callback: function($$v) {
                    _vm.isValid = $$v
                  },
                  expression: "isValid"
                }
              },
              [
                _c("v-text-field", {
                  staticClass: "portal-form-field field-wide",
                  attrs: {
                    label: _vm.$t("invoices.manual-ach.name"),
                    "hide-details": "",
                    rules: _vm.noBlank,
                    "persistent-placeholder": ""
                  },
                  model: {
                    value: _vm.accountHolderName,
                    callback: function($$v) {
                      _vm.accountHolderName = $$v
                    },
                    expression: "accountHolderName"
                  }
                }),
                _c("v-select", {
                  staticClass: "portal-form-field",
                  attrs: {
                    items: _vm.holderTypes,
                    label: _vm.$t("invoices.manual-ach.type"),
                    "hide-details": "",
                    "persistent-placeholder": ""
                  },
                  model: {
                    value: _vm.accountHolderType,
                    callback: function($$v) {
                      _vm.accountHolderType = $$v
                    },
                    expression: "accountHolderType"
                  }
                }),
                _c("v-select", {
                  staticClass: "portal-form-field",
                  attrs: {
                    items: _vm.accountTypes,
                    label: _vm.$t("invoices.manual-ach.account-type"),
                    "hide-details": "",
                    "persistent-placeholder": ""
                  },
                  model: {
                    value: _vm.accountType,
                    callback: function($$v) {
                      _vm.accountType = $$v
                    },
                    expression: "accountType"
                  }
                }),
                _c("v-text-field", {
                  staticClass: "portal-form-field",
                  attrs: {
                    label: _vm.$t("invoices.manual-ach.routing-number"),
                    "hide-details": "",
                    maxlength: "9",
                    rules: _vm.requiredRules,
                    "persistent-placeholder": ""
                  },
                  model: {
                    value: _vm.routingNumber,
                    callback: function($$v) {
                      _vm.routingNumber = $$v
                    },
                    expression: "routingNumber"
                  }
                }),
                _c("v-text-field", {
                  staticClass: "portal-form-field",
                  attrs: {
                    label: _vm.$t("invoices.manual-ach.account-number"),
                    "hide-details": "",
                    rules: _vm.requiredRules,
                    "persistent-placeholder": ""
                  },
                  model: {
                    value: _vm.accountNumber,
                    callback: function($$v) {
                      _vm.accountNumber = $$v
                    },
                    expression: "accountNumber"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "ach-form-loading" },
          [
            _c("v-progress-circular", {
              attrs: { indeterminate: "", size: 32, width: 3, color: "primary" }
            })
          ],
          1
        ),
    _c("footer", { staticClass: "ach-form-footer" }, [
      _c(
        "button",
        {
          staticClass: "dialog-action outline",
          attrs: { type: "button" },
          on: { click: _vm.handleClose }
        },
        [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
      ),
      _c(
        "button",
        {
          staticClass: "dialog-action primary",
          attrs: { type: "button", disabled: !_vm.isValid },
          on: { click: _vm.linkNewAccount }
        },
        [_vm._v(" " + _vm._s(_vm.$t("invoices.payment.new-linked")) + " ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }